import { render, staticRenderFns } from "./InvoicesCard.vue?vue&type=template&id=72c14eb0&scoped=true"
import script from "./InvoicesCard.vue?vue&type=script&lang=js"
export * from "./InvoicesCard.vue?vue&type=script&lang=js"
import style0 from "./InvoicesCard.vue?vue&type=style&index=0&id=72c14eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c14eb0",
  null
  
)

export default component.exports